// extracted by mini-css-extract-plugin
export default {"input":"styles_input__CwEBO","icon":"styles_icon__Qs4Sd"};